module.exports = __webpack_public_path__ + "static/img/big003.88d67cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big003.png
// module id = TW8/
// module chunks = 1